import React, { useState } from "react";
import PeakBrandMark from "./PeakBrandMark";
import { OnboardingVideoBackdrop, ReadinessTag } from "./OnboardingVideoBackdrop";
import { KNOW_THYSELF_CREDITS, WELCOME_INSIGHT_LEAD, WELCOME_SOCRATES } from "./onboardingCopy";

/**
 * Desktop-only brand panel shown beside the step column (hidden below `lg`).
 * Reuses the welcome video, readiness tag and "Know Thyself" copy so the
 * desktop flow keeps the same visual language as the phone welcome screen.
 */
const OnboardingSidePanel: React.FC = () => {
  const [seconds, setSeconds] = useState(0);
  return (
    <aside className="relative hidden overflow-hidden text-white lg:flex lg:w-[42%] lg:flex-col xl:w-[45%]" aria-hidden="true">
      <OnboardingVideoBackdrop intensity="panel" onTime={setSeconds} />
      <div className="relative flex flex-1 flex-col px-12 pb-12 pt-10 xl:px-16">
        <PeakBrandMark inverted enlarged />
        <ReadinessTag seconds={seconds} className="pt-5" />
        <div className="flex flex-1 flex-col justify-center gap-6">
          <div className="flex items-baseline gap-3">
            <span className="font-caveat text-[56px] leading-none xl:text-[64px]">Know Thyself.</span>
            <span className="font-funnel text-[15px] font-light italic text-white/60">{WELCOME_SOCRATES}</span>
          </div>
          <p className="max-w-[420px] font-geist text-[16px] leading-relaxed text-white/90">{WELCOME_INSIGHT_LEAD}</p>
        </div>
        <div className="grid grid-cols-2 gap-x-6 gap-y-2">
          {KNOW_THYSELF_CREDITS.slice(0, 8).map((line) => (
            <p key={line} className="font-geist text-[12px] text-white/55">{line}</p>
          ))}
        </div>
      </div>
    </aside>
  );
};

export default OnboardingSidePanel;
